<!-- Mixins-->
<div class="o-block u-text-center u-fullscreen u-overflow-auto u-bg-muted">
  <div class="o-block__cell u-flex u-flexGrow-1 u-mb-medium u-p-big">    
    <div class="u-m-auto ">
      <div class="c-formCard o-block u-collapse u-bg-main u-shadow-medium u-p-medium u-pt-none _u-width-100p _u-mb-small">
        <div class="o-block__cell"><span class="c-formCard__icon c-button  c-button--big c-button--icon u-radius-circle u-font-huge"><i class="fa fa-unlock-alt" aria-hidden="true" style="font-size: 2em"></i></span></div>
          <div *ngIf="showForm">
            <div class="o-block__cell ">
              <h2 class="u-font-regular loginTitle">RESET PASSWORD</h2>
            </div>
            <form>
              <div class="o-block__cell">
                <div class="c-control u-width-100p" [ngClass]="{'invalid-input': invalidPassword || invalidInput}">
                  <div class="c-control__input-box">
                    <input class="c-control__input" name="newPassword" type="password" placeholder="New Password" autocomplete="off" id="newPassword" required="required" [(ngModel)]="password">
                  </div>
                </div>
              </div>
              <div class="o-block__cell">
                <div class="c-control u-width-100p" [ngClass]="{'invalid-input': invalidInput}">
                  <div class="c-control__input-box">
                    <input class="c-control__input" name="confirmPassword" type="password" placeholder="Confirm New Password" autocomplete="off" id="confirmPassword" required="required" [(ngModel)]="confirmPassword">
                  </div>
                </div>
              </div>
              <div class="o-block__cell">
                <button class="c-button c-button--block" style="margin-top: 20px;" (click)="validateUser()"><span>RESET</span></button>
              </div>
            </form>
            <div class="input-container">
              <div style="font-size: 0.85rem; text-transform: uppercase; text-align: center; color: #f00;">{{errorMessage}}</div>
            </div>
          </div>
          <div *ngIf="!showForm">
            <div class="o-block__cell ">
              <h2 class="u-font-regular loginTitle">RESET PASSWORD</h2>
            </div>
            <div class="changed-succesfully">
              You have successfully reset your password
            </div>
            <div class="input-container">
              <div style="font-size: 0.85rem;text-align: center; color: #122099; cursor: pointer;" (click)="redirectToLogin()">Proceed to login page</div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
